var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.topBarTop()
  var m1 = _vm.topBarHeight()
  var m2 = !(m1 == 0) ? _vm.topBarHeight() : null
  var l0 = _vm.__map(_vm.listData, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var m3 = _vm.status == 0 ? _vm.rturnObjec(item) : null
    var m4 = _vm.progressReturn(item)
    var m5 = _vm.progressReturn(item)
    return {
      $orig: $orig,
      m3: m3,
      m4: m4,
      m5: m5,
    }
  })
  var g0 = _vm.listData.length == 0 && !_vm.loading
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        l0: l0,
        g0: g0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }